// extracted by mini-css-extract-plugin
module.exports = {"listingNewHostSlider":"NewHostSlider_listingNewHostSlider__1yBsU","removeSpacing":"NewHostSlider_removeSpacing__36CZI"};